module.exports = __webpack_public_path__ + "img/bg_pecaja.5c27abf3.jpg";